import styled, { css } from 'styled-components';
import {
    List,
    mediaMixin,
    spaceMixin,
    spacingMixin,
    token,
} from '@zillow/constellation';

export const StyledPaymentOptionsModal = styled.div`
    /**
        augmenting constellation
        designs have left and right padding of 40px
        bottom padding of 32px
        out of the box constellation padding has a value of 16px
            24 + 16 = 40
    */
    padding: ${spaceMixin('md')} ${spaceMixin('md')} ${spaceMixin('lg')} ${spaceMixin('md')};
`;

export const StyledPaymentOptionContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;

    /* 769 */
    ${mediaMixin('lg', css`
        flex-direction: row;
        align-items: flex-start;
    `)}
`;

export const StyledPaymentOptionItem = styled.div`
    ${spacingMixin};

    display: flex;
    flex-direction: column;

    margin-bottom: ${spaceMixin('sm')};

    height: 500px;
    overflow: hidden;

    width: 303px;

    border: 1px solid ${token('colors.gray300')};
    box-sizing: border-box;
    border-radius: 4px;

    /* 769 */
    ${mediaMixin('lg', css`
        margin-bottom: 0;
        /* margin-right: 54px; */

        &:last-child {
            margin-right: 0;
        }
    `)}
`;

export const StyledCTAContainer = styled.div`
    margin-top:auto;
`;

export const StyledList = styled(List)`
    margin-bottom: ${spaceMixin('md')};
    height: auto;
    overflow-y: auto;
`;
